<template src="./Add.html"></template>

<script>
import { VueEditor } from "vue2-editor";
 
export default {
  components: { VueEditor },

  data() {
    return {
      vm:{
        title: null,
        TipContent: "<h1>Some initial content</h1>",
      },
    };
  },
  
  methods: {
    confirm() {
      
      this.$store
        .dispatch("instructions/add",  this.vm )
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
  
    back() {
      this.$emit("back");
    },
  },
};
</script>

<style>
.quill-editor {
  height: 300px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  background: #fff;
}
</style>
